import { Badge, IconButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import LanguageButton from "./Reusable/LanguageButton";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { fetchCartItemsCounter } from "../actions/catalog";
import { fetchUserInfo } from "../actions/security";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const Header = (props) => {
  const { nameClass } = props || {};
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const { cartCounterItems } = useSelector((state) => state.catalogReducer);
  const isAuthenticated = loggedUserReducer?.validUser;

  const menuRef = useRef(null); // Ref za meni

  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchCartItemsCounter());
      dispatch(fetchUserInfo());
    }
  }, [dispatch]);

  // Funkcija za zatvaranje menija ako se klikne van njega
  useEffect(() => {
    const handleClickOutside = (event) => {
      const headerEl = document.querySelector(".header-container");
      if (headerEl && !headerEl.contains(event.target)) {
        setShowMenu(false);
      }
    };

    // Dodavanje event listenera na klik van menija
    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  //provera na kojoj se stranici nalazi korisnik i transparetnonst header-a
  const transparentClass =
    location.pathname === "/" ? "transparent-header" : "";

  return (
    <div className={`header-container ${nameClass} ${transparentClass}`}>
      <div className="header-holder d-flex justify-content-between align-items-center">
        <div className="header-logo">
          <img
            src="/images/logo-w-1.png"
            className="img-fluid"
            alt="LG Master Klub"
          />
        </div>
        <div className="header-logo-center">
          <img
            src="/images/master-logo-2.svg"
            className="img-fluid"
            alt="LG Master Klub"
          />
        </div>
        <div className="header-items d-flex justify-content-between align-items-center">
          {!isAuthenticated && (
            <div className="header-item">
              <LanguageButton />
            </div>
          )}
          {isAuthenticated && (
            <Fragment>
              {loggedUserReducer?.loggedUser?.accountType != "MANAGER" &&
                loggedUserReducer?.loggedUser?.companyId !=
                  "9d36797c-7a25-432c-9e47-b4b3eb5ba0d6" && (
                  <div className="header-item">
                    <IconButton
                      size="small"
                      aria-label="show more"
                      aria-haspopup="true"
                      color="inherit"
                      className="icon-header-color"
                      onClick={() => setShowMenu(false)}
                    >
                      <Link to="/cart">
                        <Badge
                          badgeContent={cartCounterItems}
                          className="badge-color-header"
                        >
                          <ShoppingBagOutlinedIcon />
                        </Badge>
                      </Link>
                    </IconButton>
                  </div>
                )}
              <div className="header-item">
                <IconButton
                  size="small"
                  aria-label="show more"
                  aria-haspopup="true"
                  color="inherit"
                  className="icon-header-color"
                  onClick={() => setShowMenu(!showMenu)}
                >
                  <img
                    src="/images/menu-bar.png"
                    className="img-fluid menu-bar-icon-header"
                    alt="LG"
                  />
                </IconButton>
              </div>
            </Fragment>
          )}
        </div>
      </div>
      <div
        ref={menuRef}
        className={`header-menu-container ${showMenu ? "active" : ""}`}
      >
        <div className="header-menu-content">
          <div className="header-menu-profile-info">
            <div className="header-main-profile-info">
              <div className="header-menu-profile-image-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                >
                  <g
                    id="Group_449"
                    data-name="Group 449"
                    transform="translate(-120 -117)"
                  >
                    <rect
                      id="Rectangle_38"
                      data-name="Rectangle 38"
                      width="16"
                      height="16"
                      rx="8"
                      transform="translate(123 120)"
                      fill="#fd312e"
                    />
                    <path
                      id="Path_27"
                      data-name="Path 27"
                      d="M6.618,2.9A1.357,1.357,0,1,0,7.975,4.261,1.357,1.357,0,0,0,6.618,2.9ZM4.357,4.261A2.261,2.261,0,1,1,6.618,6.523,2.261,2.261,0,0,1,4.357,4.261Zm-.415,5.879A2.717,2.717,0,0,1,7.394,7.992a.452.452,0,1,0,.258-.867A3.621,3.621,0,0,0,3,10.593a.452.452,0,0,0,.452.452H6.844a.452.452,0,1,0,0-.9Zm3.581-.9a.452.452,0,0,1,.452-.452h2.714a.452.452,0,1,1,0,.9H7.975A.452.452,0,0,1,7.523,9.236Z"
                      transform="translate(123.93 121.477)"
                      fill="#fff"
                      fill-rule="evenodd"
                    />
                    <g
                      id="Ellipse_6"
                      data-name="Ellipse 6"
                      transform="translate(120 117)"
                      fill="none"
                      stroke="#fd312e"
                      stroke-width="1"
                    >
                      <circle cx="11" cy="11" r="11" stroke="none" />
                      <circle cx="11" cy="11" r="10.5" fill="none" />
                    </g>
                  </g>
                </svg>
              </div>
              <h3>
                {loggedUserReducer?.loggedUser?.name}{" "}
                {loggedUserReducer?.loggedUser?.lastName}
              </h3>
            </div>
            <div className="header-secondary-profile-info">
              <div className="header-info-company-user">
                {loggedUserReducer?.userInfoList?.sector == "DEVICE_FOR_HOUSE"
                  ? t("registration.sector_name_1")
                  : loggedUserReducer?.userInfoList?.sector == "TV_AUDIO"
                  ? t("registration.sector_name_2")
                  : loggedUserReducer?.userInfoList?.sector ==
                      "DEVICE_FOR_HOUSE_AND_TV_AUDIO" &&
                    t("registration.sector_name_3")}
              </div>
              {/* <div className="header-info-company-user">
                {loggedUserReducer?.loggedUser?.accountType === "BASIC_USER"
                  ? t("registration.prodavac")
                  : t("registration.manager")}{" "}
                / {loggedUserReducer?.loggedUser?.storeName}
              </div> */}
            </div>
          </div>
          <div className="header-menu-items">
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/notification">
                <img src="/images/logo1.svg" className="img-fluid" alt="LG" />
                {t("header.notifications")}
              </Link>
            </div>
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/order">
                <img src="/images/logo2.svg" className="img-fluid" alt="LG" />
                {t("header.salesReport")}
              </Link>
            </div>
            {/* <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/user-reward">
                <img src="/images/logo3.svg" className="img-fluid" alt="LG" />
                {t("header.myRewards")}
              </Link>
            </div> */}
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/chat">
                <img src="/images/logo3.svg" className="img-fluid" alt="LG" />
                {t("header.messages")}
              </Link>
            </div>
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/promotion">
                <img src="/images/logo4.svg" className="img-fluid" alt="LG" />
                {t("header.promotions")}
              </Link>
            </div>
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/user-reward">
                <img src="/images/footer2.svg" className="img-fluid" alt="LG" />
                {t("header.myRewards")}
              </Link>
            </div>
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/task">
                <img src="/images/logo4.svg" className="img-fluid" alt="LG" />
                {t("header.tasks")}
              </Link>
            </div>
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/blog">
                <img src="/images/logo5.svg" className="img-fluid" alt="LG" />
                {t("header.news")}
              </Link>
            </div>
            {/* <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/leaderboard">
                <img src="/images/logo6.svg" className="img-fluid" alt="LG" />
                {t("header.leaderboard")}
              </Link>
            </div> */}
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/reward-list">
                <img src="/images/logo55.png" className="img-fluid" alt="LG" />
                {t("header.benefits")}
              </Link>
            </div>
            <div
              className="header-menu-item"
              onClick={() => setShowMenu(!showMenu)}
            >
              <Link to="/profile">
                <img src="/images/logo7.png" className="img-fluid" alt="LG" />
                {t("header.myProfile")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
